var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTextObsevation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.86719C0 5.3149 0.447715 4.86719 1 4.86719H17C17.5523 4.86719 18 5.3149 18 5.86719C18 6.41947 17.5523 6.86719 17 6.86719H1C0.447716 6.86719 0 6.41947 0 5.86719Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8672C0 13.3149 0.447715 12.8672 1 12.8672H14C14.5523 12.8672 15 13.3149 15 13.8672C15 14.4195 14.5523 14.8672 14 14.8672H1C0.447715 14.8672 0 14.4195 0 13.8672Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.86719C0 9.3149 0.447715 8.86719 1 8.86719H9.58823C10.1405 8.86719 10.5882 9.3149 10.5882 9.86719C10.5882 10.4195 10.1405 10.8672 9.58823 10.8672H1C0.447716 10.8672 0 10.4195 0 9.86719Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextObsevation);
export default __webpack_public_path__ + "static/media/ic-text-obsevation.e6c329a76787974efab125383979ba03.svg";
export { ForwardRef as ReactComponent };